import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SignatureState {
  /** Texto JSON original firmado (exacto, sin formato) */
  payload: string;

  /** Versión formateada del JSON (para mostrar en UI) */
  payloadPretty: string;

  /** Tipo de certificado usado (PEM / P12) */
  certificateType: string;

  /** Alias y contraseña (si aplica para P12) */
  alias?: string;
  password?: string;

  /** Firma digital generada (Base64) */
  signature?: string;

  /** Nombre del archivo de certificado */
  fileName?: string;

  /** Fecha y hora de la firma */
  signedAt?: string;

  /** Estado de carga */
  loading: boolean;

  /** Error global */
  error?: string | null;
}

const initialState: SignatureState = {
  payload: "",
  payloadPretty: "",
  certificateType: "PEM",
  alias: "",
  password: "",
  signature: "",
  fileName: "",
  signedAt: "",
  loading: false,
  error: null,
};

const qzTraySignerSlice = createSlice({
  name: "qzTraySigner",
  initialState,
  reducers: {
    /** 📦 Establecer payload manualmente (ej. payload de prueba) */
    setPayload: (state, action: PayloadAction<string>) => {
      state.payload = action.payload;
    },

    /** 🪶 Establecer la versión formateada del payload */
    setPayloadPretty: (state, action: PayloadAction<string>) => {
      state.payloadPretty = action.payload;
    },

    /** 🔐 Cambiar tipo de certificado (PEM / P12) */
    setCertificateType: (state, action: PayloadAction<string>) => {
      state.certificateType = action.payload;
    },

    setAlias: (state, action: PayloadAction<string>) => {
      state.alias = action.payload;
    },

    setPassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload;
    },

    /** ✅ Guardar resultado completo de la firma */
    setSignatureResult: (
      state,
      action: PayloadAction<{
        payload: string;
        payloadPretty: string;
        signature: string;
        fileName: string;
        signedAt: string;
      }>
    ) => {
      state.payload = action.payload.payload;
      state.payloadPretty = action.payload.payloadPretty;
      state.signature = action.payload.signature;
      state.fileName = action.payload.fileName;
      state.signedAt = action.payload.signedAt;
      state.loading = false;
    },

    /** ⏳ Control de carga */
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    /** ⚠️ Manejo de errores */
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },

    /** 🧹 Reiniciar todo el estado */
    resetSignature: () => initialState,
  },
});

export const {
  setPayload,
  setPayloadPretty,
  setCertificateType,
  setAlias,
  setPassword,
  setSignatureResult,
  setLoading,
  setError,
  resetSignature,
} = qzTraySignerSlice.actions;

export default qzTraySignerSlice.reducer;
